<template>
 <drawer-bottom show="{{ show }}" title="筛选" customStyle="{{drawerStyle}}" bind:close="close" showDefaultNav="{{true}}">
    <view class="es-filter-condition-container">
      <view wx:if="{{isTransfer}}" class="es-filter-condition">
        <view class="es-filter-header">
          推荐筛选
        </view>
        <view class="es-filter-type">
          <view
            class="es-filter-type-item"
            wx:for="{{TRANSFER_STATION_TYPE}}"
            wx:class="{{transferStationType === item.type && 'select'}}"
            catchtap="selectFilterCondition('transfer_station_type', item.type)"
            >{{item.text}}</view
          >
        </view>
      </view>
      <view class="es-filter-condition" wx:if="{{!isTransfer}}">
        <view class="es-filter-header">
          特殊筛选
        </view>
        <view class="es-filter-type">
          <view
            wx:if="{{!isScramble && !isTransfer}}"
            class="es-filter-type-item"
            wx:class="{{ticketsSelected && 'select'}}"
            catchtap="selectFilterCondition('preferred_tickets')"
            >仅看有票</view
          >
          <view
            class="es-filter-type-item"
            wx:class="{{isFxh && 'select'}}"
            catchtap="selectFilterCondition('is_fxh')"
            >复兴号</view
          >
          <view
            class="es-filter-type-item"
            wx:class="{{isZN && 'select'}}"
            catchtap="selectFilterCondition('zndc')"
            >智能动车</view
          >
          <view
            class="es-filter-type-item"
            wx:class="{{isStudent && 'select'}}"
            catchtap="selectFilterCondition('student')"
            >学生票</view
          >
          <view
            class="es-filter-type-item"
            wx:class="{{isQuiet && 'select'}}"
            catchtap="selectFilterCondition('is_quiet')"
            >静音车厢</view
          >
        </view>
      </view>
      <view class="es-filter-condition">
        <view class="es-filter-header">
          车型选择
        </view>
        <view class="es-filter-type">
          <view
            wx:for="{{this.isTransfer ? TRANSFER_TRAIN_TYPE : TRAIN_TYPE}}"
            class="es-filter-type-item"
            wx:class="{{trainType && trainType.includes(item.type) && 'select'}}"
            catchtap="selectFilterCondition('train_type_code', item.type)"
            >{{item.text}}</view
          >
        </view>
      </view>
      <view class="es-filter-condition">
        <view class="es-filter-header">
          出发时间
        </view>
        <view class="es-filter-type">
          <view
            class="es-filter-type-item"
            wx:for="{{TRAIN_TIME}}"
            wx:key="index"
            wx:class="{{fromTime && fromTime.includes(item.queryTime[1]) && 'select'}}"
            catchtap="selectFilterCondition('start_time_list', item)"
          >
            {{ item.showTime }}
          </view>
        </view>
      </view>
      <view class="es-filter-condition">
        <view class="es-filter-header">
          到达时间
        </view>
        <view class="es-filter-type">
          <view
            class="es-filter-type-item"
            wx:for="{{TRAIN_TIME}}"
            wx:key="index"
            wx:class="{{toTime && toTime.includes(item.queryTime[1]) && 'select'}}"
            catchtap="selectFilterCondition('end_time_list', item)"
          >
            {{ item.showTime }}
          </view>
        </view>
      </view>
      <view class="es-filter-condition" wx:if="{{!isScramble}}">
        <view class="es-filter-header">
          出发站点
        </view>
        <view class="es-filter-type">
          <view
            class="es-filter-type-item"
            wx:for="{{from_station_list}}"
            wx:key="index"
            wx:class="{{fromStation && fromStation.includes(item)  && 'select'}}"
            catchtap="selectFilterCondition('from_city_match', item)"
          >
            {{ item }}
          </view>
        </view>
      </view>
      <view class="es-filter-condition" wx:style="{{{marginBottom: '20px'}}}" wx:if="{{!isScramble}}">
        <view class="es-filter-header">
          到达站点
        </view>
        <view class="es-filter-type">
          <view
            class="es-filter-type-item"
            wx:for="{{to_station_list}}"
            wx:key="index"
            wx:class="{{toStation && toStation.includes(item) && 'select'}}"
            catchtap="selectFilterCondition('to_city_match', item)"
          >
            {{ item }}
          </view>
        </view>
      </view>
      <view class="es-filter-condition" wx:style="{{{marginBottom: '20px'}}}" wx:if="{{isTransfer}}">
        <view class="es-filter-header">
          中转城市
        </view>
        <view class="es-filter-type">
          <view
            class="es-filter-type-item"
            wx:if="{{transfer_station_list?.length}}"
            wx:for="{{transfer_station_list}}"
            wx:key="index"
            wx:class="{{transferStation && transferStation.includes(item) && 'select'}}"
            catchtap="selectFilterCondition('transfer_city_match', item)"
          >
            {{ item }}
          </view>
        </view>
      </view>
      <view class="footer-shadow" />
    </view>
    <view class="es-filter-condition-container-footer">
      <view class="btn default" catchtap="resetSortCriteria">重置</view>
      <view class="btn primary" catchtap="search">确定</view>
    </view>
  </drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { setStorage } from '@/utils/storage'
  import { STORAGE_LIST_SEARCH_QUERY } from '@/utils/train-storage'
  import initMixin from '@/mixins'

  createComponent({
    mixins: [initMixin],
    props: {
      show: Boolean,
      trainListSearchQuery: {
        type: Object,
        value: {}
      },
      selectCityList: {
        type: Array,
        value: []
      },
      condition: Object,
      isScramble: {
        type: Boolean,
        value: false
      },
      unionType: {
        type: Number,
        value: 0
      }
    },
    data: {
      drawerStyle: {
        'min-height': '80vh'
      }
    },
    mounted() {
      // console.log('222this.condition', this.condition)
      // const _condition = getStorage(STORATE_CONDITION_SEARCH_QUERY)
      // !this.isScramble &&
      //   _condition &&
      //   Object.keys(_condition).length &&
      //   (this.condition = { ..._condition })
    },
    computed: {
      ...store.mapState({
        TRAIN_TIME: 'train.TRAIN_TIME',
        TRAIN_TYPE: 'train.TRAIN_TYPE',
        TRANSFER_TRAIN_TYPE: 'train.TRANSFER_TRAIN_TYPE',
        TRANSFER_STATION_TYPE: 'train.TRANSFER_STATION_TYPE',
        trainListInfo: 'train.trainListInfo',
        from_station_list: 'train.trainListInfo.from_station_list',
        to_station_list: 'train.trainListInfo.to_station_list',
        transfer_station_list: 'train.trainListInfo.transfer_station_list',
      }),
      // trainType() {
      //   let trainType = this.condition.train_type_code || []
      //   trainType = {
      //     CDG: trainType?.includes('1,2'), // C,D,G 高铁动车
      //     KSTYZ: trainType?.includes('3') // K,S,T,Y,Z 普通车
      //   }
      //   return trainType
      // },
      trainType() {
        return this.condition.train_type_code
      },
      fromTime() {
        return this.condition.start_time_list
      },
      toTime() {
        return this.condition.end_time_list
      },
      fromStation() {
        return this.condition.from_city_match
      },
      toStation() {
        return this.condition.to_city_match
      },
      transferStation() {
        return this.condition.transfer_city_match
      },
      transferStationType() {
        return this.condition.transfer_station_type
      },
      ticketsSelected() {
        return this.condition?.preferred_tickets === '1'
      },
      isFxh() {
        return this.condition?.is_fxh === '1'
      },
      isZN() {
        // return 
        return this.condition?.is_zndc === '1'
      },
      isStudent() {
        return this.condition?.passenger_type === '13'
      },
      isQuiet() {
        return this.condition?.is_quiet === '1'
      },
      isTransfer() {
        return !!this.unionType
      }
    },
    methods: {
      close() {
        this.newTrainListSearchQuery = undefined
        this.$trigger('close')
      },
      selectFilterCondition(type, param) {
        console.log('type==', type, 'param==', param)
        const {
          train_type_code,
          start_time_list,
          end_time_list,
          from_city_match,
          to_city_match,
          transfer_city_match,
          transfer_station_type
        } = this.condition
        let condition
        switch (type) {
          case 'train_type_code':
            condition = train_type_code.includes(param)
              ? {
                  ...this.condition,
                  train_type_code: train_type_code.filter((item) => item !== param)
                }
              : { ...this.condition, train_type_code: [...train_type_code, param] }
            break
          case 'start_time_list':
            condition = start_time_list?.includes(param.queryTime[1])
              ? {
                  ...this.condition,
                  start_time_list: start_time_list?.filter(
                    (item) => item !== param.queryTime[0] && item !== param.queryTime[1]
                  )
                }
              : {
                  ...this.condition,
                  start_time_list: [...start_time_list, param.queryTime[0], param.queryTime[1]]
                }
            break
          case 'end_time_list':
            condition = end_time_list?.includes(param.queryTime[1])
              ? {
                  ...this.condition,
                  end_time_list: end_time_list?.filter(
                    (item) => item !== param.queryTime[0] && item !== param.queryTime[1]
                  )
                }
              : {
                  ...this.condition,
                  end_time_list: [...end_time_list, param.queryTime[0], param.queryTime[1]]
                }
            break
          case 'from_city_match':
            condition = from_city_match.includes(param)
              ? {
                  ...this.condition,
                  from_city_match: from_city_match.filter((item) => item !== param)
                }
              : { ...this.condition, from_city_match: [...from_city_match, param] }
            break
          case 'to_city_match':
            condition = to_city_match.includes(param)
              ? { ...this.condition, to_city_match: to_city_match.filter((item) => item !== param) }
              : { ...this.condition, to_city_match: [...to_city_match, param] }
            break
          case 'transfer_city_match':
            condition = transfer_city_match.includes(param)
              ? {
                  ...this.condition,
                  transfer_city_match: transfer_city_match.filter((item) => item !== param)
                }
              : { ...this.condition, transfer_city_match: [...transfer_city_match, param] }
            break
          case 'transfer_station_type':
            condition = {
              ...this.condition,
              transfer_station_type: transfer_station_type === param ? 0 : param
            }
            break
          case 'preferred_tickets':
            condition = { ...this.condition, preferred_tickets: this.ticketsSelected ? '0' : '1' }
            break
          case 'is_fxh':
            condition = { ...this.condition, is_fxh: this.isFxh ? '0' : '1' }
            break
          case 'student':
            condition = { ...this.condition, passenger_type: this.isStudent ? '11' : '13' }
            break
          case 'zndc':
            condition = { ...this.condition, is_zndc: this.isZN ? '0' : '1' }
            break
          case 'is_quiet':
            condition = { ...this.condition, is_quiet: this.isQuiet ? '0' : '1' }
            break
        }
        this.$trigger('conditionChange', condition)
      },
      resetSortCriteria() {
        const condition = {
          train_type_code: [],
          start_time_list: [],
          end_time_list: [],
          from_city_match: [],
          to_city_match: [],
          passenger_type: '',
          preferred_tickets: '',
          is_fxh: '',
          is_zndc: '',
          is_quiet: '',
          transfer_station_type: 0,
          transfer_city_match: [],
        }
        this.$trigger('conditionChange', condition)
        // const trainListSearchQuery = { ...this.trainListSearchQuery }
        // trainListSearchQuery.preferred_tickets = '0'
        // trainListSearchQuery.train_type_code = []
        // trainListSearchQuery.from_city_match = ''
        // trainListSearchQuery.to_city_match = ''
        // !this.isScramble &&
        //   setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: trainListSearchQuery })
      },
      getTrainListFunc() {
        this.$trigger('getTrainListFunc')
      },
      search() {
        const trainListSearchQuery = { ...this.trainListSearchQuery }
        Object.entries(this.condition).map(([key, value]) => {
          if (key === 'train_type_code') {
            if (value.length) {
              trainListSearchQuery[key] = value.join(',')
            } else {
              trainListSearchQuery[key] = ''
            }
          }
          if (key === 'start_time_list') {
            if (value) {
              trainListSearchQuery.start_time_list = JSON.stringify(value)
            } else {
              trainListSearchQuery.start_time_list = ['']
            }
          }
          if (key === 'end_time_list') {
            if (value) {
              trainListSearchQuery.end_time_list = JSON.stringify(value)
            } else {
              trainListSearchQuery.end_time_list = ['']
            }
          }
          if (key === 'from_city_match') {
            trainListSearchQuery[key] = value.join(',')
          }
          if (key === 'to_city_match') {
            trainListSearchQuery[key] = value.join(',')
          }
          if(key === 'preferred_tickets') {
            trainListSearchQuery.preferred_tickets = value
          }
          if(key === 'is_fxh') {
            trainListSearchQuery.is_fxh = value
          }
          if(key === 'is_zndc') {
            trainListSearchQuery.is_zndc = value
          }
          if(key === 'passenger_type') {
            trainListSearchQuery.passenger_type = value
          }
          if(key === 'is_quiet') {
            trainListSearchQuery.is_quiet = value
          }
          if(key === 'transfer_city_match') {
           trainListSearchQuery[key] = value.join(',')
          }
          if(key === 'transfer_station_type') {
            trainListSearchQuery.transfer_station_type = value
          }
        })
       !this.isScramble &&
          setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: trainListSearchQuery })
        this.$trigger('parentDataChange', {
          key: 'trainListSearchQuery',
          value: trainListSearchQuery
        })
        this.getTrainListFunc()
        this.close()
      }
    }
  })
</script>
<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .es-filter-condition-container
    padding 8px 21px 0 20px
    overflow scroll
    .es-filter-condition
      margin-bottom 12px
      font-size 14px
      font-weight 400
      .es-filter-header
        margin-bottom 12px
        font-family PingFangSC-Medium
      .es-filter-type
        display grid 
        grid-template-columns: repeat(3, 1fr)
        grid-gap 8px
        justify-items center 
        align-items center
        .es-filter-type-item
          width 100%
          height 30px
          line-height 30px
          border-radius 6px
          background #fff
          text-align center 
          font-size 12px
          border 0.5px solid #CCCCCC
          color #666666
          font-family PingFangSC-Regular
        .es-filter-type-item.select
          color #222222
          border 0.5px solid #FF6400
          font-family PingFangSC-Medium
          position relative
          // overflow hidden
          &::after 
            content ''
            position absolute 
            bottom 0
            right 0
            width 10px
            height 10px
            background url('https://dpubstatic.udache.com/static/dpubimg/QbadIsbSV7H9PID73EIiG.png')
            background-size cover
  .footer-shadow
    height 88px
  .es-filter-condition-container-footer
    position fixed
    bottom 0
    width 100%
    height 88px
    padding-top 16px
    box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
    display flex
    background #ffffff
    justify-content space-between
    .btn
      width 100%
      height 50px
      border-radius 10px
      font-size 16px
      font-weight 500
      text-align center
      line-height 48px
      &.default
        color #333333
        background #fff
        border: 1px solid #CCCCCC
        margin-left 20px
        font-family PingFangSC-Medium
      &.primary
        color #ffffff
        background #FF6400
        margin-right 20px
        margin-left 11px
        font-family PingFangSC-Semibold
</style>
<script  name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom'
    }
  }
</script>
